module.exports = __webpack_public_path__ + "static/yunlong_song-2867dd1602fa78cf0925ef85ce0f5162.jpg";